module.exports = __webpack_public_path__ + "static/media/carousel_new.c88ceb02.svg";